import {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import {Button, Input, Space, Spin, Table} from 'antd';
import moment from 'moment';

import {Membership} from '../../graphql/API';
import {MembershipsService} from './MembershipsService';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import {SearchOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import {get, isEqual} from 'lodash';

const membershipsService = new MembershipsService();

export const MembershipsTable = () => {
  const [memberships, setMemberships] = useState<Array<Membership> | []>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchedColumn, setSearchedColumn] = useState<any>();
  const [searchText, setSearchText] = useState<any>();
  let searchInput = useRef();

  useEffect(() => {
    membershipsService
      .getMemberships()
      .then((resp) => {
        setIsLoading(false);
        setMemberships(resp);
      })
      .catch((error) => {
        setIsError(true);
        //console.log('Error ->', error);
      });
  }, []);

  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => (
      <div style={{padding: 8}}>
        <Input
          ref={(node) => {
            // @ts-ignore
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{marginBottom: 8, display: 'block'}}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{width: 90}}>
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{width: 90}}>
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({closeDropdown: false});
              setSearchedColumn(dataIndex);
              setSearchText(selectedKeys[0]);
            }}>
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}} />
    ),
    onFilter: (value: any, record: any) =>
      get(record, dataIndex)
        ? get(record, dataIndex)
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible: any) => {
      if (visible) {
        // @ts-ignore
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text: any) =>
      isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
    confirm();
    setSearchedColumn(dataIndex);
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters: any) => {
    clearFilters();
    setSearchText('');
  };
  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      ...getColumnSearchProps('id'),
      sorter: (a: any, b: any) => a.id.length - b.id.length,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (id: string) => (
        <Link to={'/memberships/' + id + '/edit'}>{id}</Link>
      ),
    },
    {
      title: 'Created at',
      dataIndex: ['createdAt'],
      defaultSortOrder: 'descend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a: any, b: any) =>
        moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
    {
      title: 'active?',
      dataIndex: ['isActive'],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a: any, b: any) => a.isActive - b.isActive,
      render: (isActive: boolean) => (
        <p
          style={{
            color: isActive ? 'green' : 'red',
          }}>
          {isActive ? 'YES' : 'NO'}
        </p>
      ),
    },

    {
      title: 'PaymentStatus',
      key: 'paymentStatus',
      dataIndex: 'paymentStatus',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a: any, b: any) => {
        return a.paymentStatus.localeCompare(b.paymentStatus);
      },
      render: (paymentStatus: string) => (
        <p
          style={{
            color:
              paymentStatus === 'DONE'
                ? 'green'
                : paymentStatus === 'DOING'
                ? '#E2D410'
                : 'red',
          }}>
          {paymentStatus}
        </p>
      ),
    },
    {
      title: 'Student',
      dataIndex: ['student', 'name'],
      ...getColumnSearchProps(['student', 'id']),
      render: (studentName: string, record: Membership) => (
        <Link to={'/students/' + record.student.id}>
          {`${record.student?.name} / ${record.student?.id?.split('-')[0]}`}
        </Link>
      ),
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a: any, b: any) => {
        return a.student.name.localeCompare(b.student.name);
      },
    },
  ];

  return (
    <>
      {/* <Button size={'large'} style={{float: 'right', margin: 20}}>
        <Link to={'/memberships/create'}>Create</Link>
      </Button> */}
      {!isError && !isLoading && (
        <Table
          pagination={{defaultPageSize: 100}}
          columns={columns}
          dataSource={memberships}
        />
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Memberships fetching error ⚠️</Title>}
    </>
  );
};
